import React from 'react';
import { useTranslations } from '../translations/translations';
import { useFadeIn } from '../hooks/useFadeIn';

const AboutSection = () => {
  const t = useTranslations();
  const [ref, isVisible] = useFadeIn(0.1);
  
  return (
    <section 
      ref={ref}
      className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
      style={{ 
        padding: '4rem 0', 
        background: '#000',
        borderTop: '1px solid #1a1a1a'
      }}
    >
      <div className="container-custom">
        <div style={{ 
          maxWidth: '1100px',
          margin: '0 auto',
          textAlign: 'left'
        }}>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#d4d4d4',
            lineHeight: 1.7,
            fontWeight: 300,
            marginBottom: '1rem'
          }}>
            {t.about.text1}
          </p>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#d4d4d4',
            lineHeight: 1.7,
            fontWeight: 300,
            marginBottom: '1rem'
          }}>
            {t.about.text2}
          </p>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#d4d4d4',
            lineHeight: 1.7,
            fontWeight: 300,
            marginBottom: '1rem'
          }}>
            {t.about.text3}
          </p>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#d4d4d4',
            lineHeight: 1.7,
            fontWeight: 300,
            marginBottom: '1rem'
          }}>
            {t.about.text4}
          </p>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#d4d4d4',
            lineHeight: 1.7,
            fontWeight: 300
          }}>
            {t.about.text5}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
